import api from "./api";

const PettyCashReportService = {
  getReport: async (params) => {
    const response = await api.get("/pettyCashReport/getReport", {
      params: {
        companyId: params.companyId || undefined,
        employeeId: params.employeeId || undefined,
        projectId: params.projectId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;
  },
};

export default PettyCashReportService;
